export default "__VITE_ASSET__kDIavorT__"